import { render, staticRenderFns } from "./framework-view.vue?vue&type=template&id=41186e69&"
import script from "./framework-view.vue?vue&type=script&lang=js&"
export * from "./framework-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports